module.exports = __webpack_public_path__ + "img/image19.d5c11f56.jpg";